<section class="home-slider-area">
    <div class="home-slider-container default-slider-container">
        <div class="home-slider-wrapper slider-default">
            <div class="slider-content-area"
                style="background-image: url('../../../../assets/images/new-images/slider-bg.png');">
                <div class="container pt--0 pb--0">
                    <div class="slider-container">
                        <div class="row justify-content-center align-items-center">
                            <div class="col-12 col-lg-8">
                                <div class="slider-content">
                                    <h2 class="title"><span class="counter" data-counterup-delay="80">Empowering Your
                                            Journey from Learning to Earning.</span>
                                    </h2>
                                    <p class="desc">
                                        Explore Jobs, Internships & Ignite Your Startup Dreams Here.

                                    </p>
                                </div>
                            </div>
                            <div class="col-12 text-center">
                                <input type="checkbox" id="searchToggle" hidden>
                                <label for="searchToggle" class="search-toggle-label">
                                    <span class="toggle-option job-label">Job Search</span>
                                    <span class="toggle-switch"></span>
                                    <span class="toggle-option internship-label">Internship Search</span>
                                </label>
                                <!-- Toggle Content -->
                                <div class="search-form-toggle mt-3">
                                    <div class="job-form">
                                        <!-- Job Search Form Here -->
                                        <div class="job-search-wrap">
                                            <div class="job-search-form">
                                                <form action="#">
                                                    <div class="row row-gutter-10">
                                                        <div class="col-lg-auto col-sm-6 col-12 flex-grow-1">
                                                            <div class="form-group">
                                                                <input type="text" class="form-control"
                                                                    placeholder="Job title or keywords">
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-auto col-sm-6 col-12 flex-grow-1">
                                                            <div class="form-group">
                                                                <select class="form-control">
                                                                    <option selected>Choose City</option>
                                                                    <option>New York</option>
                                                                    <option>California</option>
                                                                    <option>Illinois</option>
                                                                    <option>Texas</option>
                                                                    <option>Florida</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-auto col-sm-6 col-12 flex-grow-1">
                                                            <div class="form-group">
                                                                <select class="form-control">
                                                                    <option selected>Category</option>
                                                                    <option>Web Designer</option>
                                                                    <option>Web Developer</option>
                                                                    <option>Graphic Designer</option>
                                                                    <option>App Developer</option>
                                                                    <option>UI & UX Expert</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-auto col-sm-6 col-12 flex-grow-1">
                                                            <div class="form-group">
                                                                <button type="button" class="btn-form-search">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                                                        height="16" fill="currentColor"
                                                                        class="bi bi-search" viewBox="0 0 16 16">
                                                                        <path
                                                                            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="internship-form">
                                        <!-- Internship Search Form Here -->
                                        <div class="job-search-wrap">
                                            <div class="job-search-form">
                                                <form action="#">
                                                    <div class="row row-gutter-10">
                                                        <div class="col-lg-auto col-sm-6 col-12 flex-grow-1">
                                                            <div class="form-group">
                                                                <input type="text" class="form-control"
                                                                    placeholder="Job title or keywords">
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-auto col-sm-6 col-12 flex-grow-1">
                                                            <div class="form-group">
                                                                <select class="form-control">
                                                                    <option selected>Choose City</option>
                                                                    <option>New York</option>
                                                                    <option>California</option>
                                                                    <option>Illinois</option>
                                                                    <option>Texas</option>
                                                                    <option>Florida</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-auto col-sm-6 col-12 flex-grow-1">
                                                            <div class="form-group">
                                                                <select class="form-control">
                                                                    <option selected>Category</option>
                                                                    <option>Web Designer</option>
                                                                    <option>Web Developer</option>
                                                                    <option>Graphic Designer</option>
                                                                    <option>App Developer</option>
                                                                    <option>UI & UX Expert</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-auto col-sm-6 col-12 flex-grow-1">
                                                            <div class="form-group">
                                                                <button type="button" class="btn-form-search">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                                                        height="16" fill="currentColor"
                                                                        class="bi bi-search" viewBox="0 0 16 16">
                                                                        <path
                                                                            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container pt--0 pb--0">
        <div class="row">
            <div class="col-12">
                <div class="play-video-btn" data-bs-toggle="modal" data-bs-target="#videoModal"
                    style="cursor: pointer;">
                    <div class="video-popup">
                        <i class="bi bi-play-fill text-white fa-2x"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="home-slider-shape">
        <img class="shape1" data-aos="fade-down" data-aos-duration="1500"
            src="../../../../assets/images/new-images/vector1.png" width="270" height="234" alt="Image-HasTech">
        <img class="shape2" data-aos="fade-left" data-aos-duration="2000"
            src="../../../../assets/images/new-images/vector2.png" width="201" height="346" alt="Image-HasTech">
        <img class="shape3" data-aos="fade-right" data-aos-duration="2000"
            src="../../../../assets/images/new-images/vector3.png" width="276" height="432" alt="Image-HasTech">
        <img class="shape4" data-aos="flip-left" data-aos-duration="1500"
            src="../../../../assets/images/new-images/vector4.png" width="127" height="121" alt="Image-HasTech">
    </div>
</section>

<!-- Bootstrap Modal -->
<div class="modal fade" id="videoModal" tabindex="-1" aria-labelledby="videoModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-dark">
            <div class="modal-body p-0 position-relative">
                <!-- Close Button -->
                <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal"
                    aria-label="Close"></button>

                <!-- Embedded YouTube Video -->
                <div class="ratio ratio-16x9">
                    <iframe width="853" height="480" src="https://www.youtube.com/embed/QMPPZnAmTzk"
                        title="animation video for online job search" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</div>